/**
 * Helper for checking deep-equality.
 * Only supports arrays and plain objects, and otherwise compares using ===
 * @param {*} a
 * @param {*} b
 * @returns true if a and b are deep-equal, false otherwise
 */
export function isEqual(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((item, index) => {
      return isEqual(a[index], b[index]);
    });
  } else if (a === null && b === null) {
    return true;
  } else if (a === null || b === null) {
    return false;
  } else if (typeof a === 'object' && typeof b === 'object') {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key) => {
      return isEqual(a[key], b[key]);
    });
  } else {
    return a === b;
  }
}
